// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","footerContainer":"Footer_footerContainer__yunXS","footerText":"Footer_footerText__y-wf5"};